<template>
    <div class="d-flex justify-content-center">
        <h4 class="product-price">
            {{ product.PricePrefix }}
            <Pula :amount="+price" :suffix="product.PriceSuffix" />
        </h4>
    </div>
</template>

<script>
import Pula from "./Pula";
import {
    getProductPrice,
    isDeviceProduct
} from "../services/ProductPriceCalculator";

export default {
    name: "ProductPrice",
    components: {
        Pula
    },
    props: {
        product: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            price: null
        };
    },
    created() {
        this.price = this.getProductPrice(this.product);
    },
    methods: {
        getProductPrice(product) {
            if (
                !window.location.pathname.toLowerCase().startsWith("/devices")
            ) {
                product.PriceSuffix = " per month";

                const productIsDevice = isDeviceProduct(product);
                if (productIsDevice) {
                    product.PricePrefix = "From";
                }
                return getProductPrice(product);
            }
            return product.Price;
        }
    }
};
</script>
